import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { map, Observable } from 'rxjs';
import { SabisNgxDialogService } from 'sabis-components2';
import { ApplicationStatusDialogData, JobApplicationStatusComponent } from '../../candidates/job-application-status/job-application-status.component';
import { ApprovalsListComponent } from '../../hiring-requests/approvals/approvals-list/approvals-list.component';
import { PermissionsDialogData, PermissionsEditorComponent } from '../../candidates/recruitment/permissions-editor/permissions-editor.component';
import { CollectFeedbackDialogData, CollectFeedbackRequestEditorComponent } from '../../candidates/recruitment/collect-feedback-request-editor/collect-feedback-request-editor.component';
import { CollectFeedbackCommand } from '../../candidates/recruitment/step-feedback/step-feedback.service';
import { ApplicationFeedbackType } from './../../candidates/recruitment/models/api-models';
import { FormTemplateType } from '../../shared/dynamic-forms/templates/editor-models';

@Injectable({
  providedIn: 'root'
})
export class AppNavigationService {

  constructor(private _router: Router, private _dialog: SabisNgxDialogService) { }

  public goToContinentsList(): void {
    this._router.navigate(['settings', 'continents']);
  }

  /** Redirect to job requisition editor
   * @param jobRequisitionId Job requisition id to edit
   */
  public goToEditJobRequisition(jobRequisitionId: number): void {
    this._router.navigate(['job-requisitions', jobRequisitionId]);
  }

  public goToJobRequisitionsList(isMyRequisitions?: boolean, isLiveRequisitions?: boolean, isExpiredRequisitions?: boolean, isPendingApprovalRequisitions?: boolean, isClosedRequisitions?: boolean, isDraftRequisitions?: boolean, isExpiringRequisitions?: boolean): void {
    this._router.navigate(['job-requisitions', 'list'], {
      queryParams: {
        'myRequisitions': isMyRequisitions,
        'liveRequisitions': isLiveRequisitions,
        'expiredRequisitions': isExpiredRequisitions,
        'pendingApprovalRequisitions': isPendingApprovalRequisitions,
        'closedRequisitions': isClosedRequisitions,
        'draftRequisitions': isDraftRequisitions,
        'expiringRequisitions': isExpiringRequisitions
      }
    });
  }
  public getJobRequisitionIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['jobRequisitionId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }
  public isMyRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['myRequisitions'];
    return value === 'true';
  }
  public isLiveRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['liveRequisitions'];
    return value === 'true';
  }
  public isExpiredRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['expiredRequisitions'];
    return value === 'true';
  }
  public isPendingApprovalRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['pendingApprovalRequisitions'];
    return value === 'true';
  }
  public isClosedRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['closedRequisitions'];
    return value === 'true';
  }
  public isExpiringRequisitions(route: ActivatedRoute): boolean {
    let value = route.snapshot.queryParams['expiringRequisitions'];
    return value === 'true';
  }



  /**
   * Navigate to Job Vacancy form with param
   * @param hiringRequestId
   */
  public goToEditHiringRequest(hiringRequestId: number): void {
    this._router.navigate(['hiring-requests', hiringRequestId]);
  }
  /**Navigate to list of job vacancies */
  public goToHiringRequestsList(): void {
    this._router.navigate(['hiring-requests', 'list']);
  }

  public goToHiringRequestApprovals(hiringRequestId: number): void {
    var dialog = this._dialog.open(ApprovalsListComponent, {
      hasBackdrop: true,
      panelClass: 'sc-modal',
      minWidth: '600px',
      data: {
        hiringRequestId: hiringRequestId
      }
    });
    dialog.afterClosed().subscribe(r => {

    });
  }

  /**
   * get job vacancy id from url
   * @param route
   * @returns
   */
  public getHiringRequestIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['hiringRequestId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToEditJobDescription(jobDescriptionId: number): void {
    this._router.navigate(['settings', 'job-descriptions', jobDescriptionId]);
  }
  public getJobDescriptionIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['jobPositionId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToCreateJobDescription(): void {
    this._router.navigate(['settings', 'job-descriptions', 'new']);
  }
  public goToJobDescriptionList(): void {
    this._router.navigate(['settings', 'job-descriptions', 'list']);
  }

  public goToAddUser(): void {
    this._router.navigate(['settings', 'users', 'new']);
  }
  public goToEditUser(userId: number): void {
    this._router.navigate(['settings', 'users', userId]);
  }
  public goToUsersList(): void {
    this._router.navigate(['settings', 'users', 'list']);
  }
  public getUserIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['userId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToAccessDenied(): void {
    this._router.navigate(['access-denied']);
  }

  public goToAddWorkflow(): void {
    this._router.navigate(['settings', 'workflows', 'new']);
  }
  public goToEditWorkflow(hiringRequestWorkflowId: number): void {
    this._router.navigate(['settings', 'workflows', hiringRequestWorkflowId]);
  }
  public goToWorkflowsList(): void {
    this._router.navigate(['settings', 'workflows', 'list']);
  }
  public getWorkflowIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['hiringRequestWorkflowId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToAddFeedbackFormTemplate(): void {
    this._router.navigate(['settings', 'feedback-forms', 'templates', 'new'], {
      queryParams: {
        'template-type': FormTemplateType.Feedback
      }
    });
  }
  public goToViewFeedbackFormTemplate(templateId: number): void {
    this._router.navigate(['settings', 'feedback-forms', 'templates', templateId], {
      queryParams: {
        'template-type': FormTemplateType.Feedback
      }
    });
  }
  public goToFeedbackFormTemplatesList(): void {
    this._router.navigate(['settings', 'feedback-forms', 'templates']);
  }

  public goToAddRecruitmentEventFormTemplate(): void {
    this._router.navigate(['settings', 'recruitment-event-forms', 'templates', 'new'], {
      queryParams: {
        'template-type': FormTemplateType.RecruitmentEventApplication
      }
    });
  }

  public goToViewRecruitmentEventFormTemplate(templateId: number): void {
    this._router.navigate(['settings', 'recruitment-event-forms', 'templates', templateId], {
      queryParams: {
        'template-type': FormTemplateType.RecruitmentEventApplication
      }
    });
  }

  public goToRecruitmentEventFormTemplatesList(): void {
    this._router.navigate(['settings', 'recruitment-event-forms', 'templates']);
  }

  public getTemplateId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['templateId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToAddApplicationFormTemplate(): void {
    this._router.navigate(['settings', 'application-forms', 'templates', 'new'], {
      queryParams: {
        'template-type': FormTemplateType.Application
      }
    });
  }
  public goToViewApplicationFormTemplate(templateId: number): void {
    this._router.navigate(['settings', 'application-forms', 'templates', templateId], {
      queryParams: {
        'template-type': FormTemplateType.Application
      }
    });
  }

  public goToApplicationFormTemplatesList(): void {
    this._router.navigate(['settings', 'application-forms', 'templates']);
  }

  public getApplicationTemplateId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['templateId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public getFormInstanceId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['instanceId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  /**
   * Get form template type from route query param
   * @param route current route
   * @returns
   */
  public getTemplateType(route: ActivatedRoute): FormTemplateType | null {
    let realValue = route.snapshot.queryParams['template-type'];
    if (!!realValue) {
      return realValue;
    }

    return null;
  }

  /**
   * Redirect to requisition candidates list
   * @param jobRequisitionId Job requisition id
   * @param applicationStatusIds Application status ids to filter the candidates list
   * @param isForGeneralApplications
   * @param countryId
   * @param getUnprocessedApplications Get general applications that are not yet processed (New, Open)
   */
  public goToCandidatesList(jobRequisitionId: number | null, applicationStatusIds: number[], isForGeneralApplications: boolean, countryId: number | null, getUnprocessedApplications: boolean | null): void {
    var queryParams = !!jobRequisitionId || isForGeneralApplications || countryId ? {
      'jrId': jobRequisitionId,
      'sIds': applicationStatusIds.length > 0 ? applicationStatusIds.join() : null, // application status ids filter
      'isGeneral': isForGeneralApplications,
      'cId': countryId,
      'unprocessed': getUnprocessedApplications
    } : null;

    this._router.navigate(['candidates', 'filtered'], {
      queryParams: queryParams
    });
  }

  public getJobRequisitionIdCandidateFilter(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.queryParams['jrId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }
  public goToCandidateProfile(candidateId: number): void {
    this._router.navigate(['candidates', candidateId]);
  }

  /**
   * Redirect to candidate profile with current requisition set to active
   * @param jobRequisitionId Job requisition id
   */
  public goToCandidateProfileWithActiveRequisition(candidateId: number, jobRequisitionId: number): void {
    this._router.navigate(['candidates', candidateId], {
      queryParams: {
        'jrId': jobRequisitionId
      }
    });
  }

  public getCandidateId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['candidateId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  // email
  public goToFailedEmails(): void {
    this._router.navigate(['emails', 'failed', 'list']);
  }
  public goToPreviewEmail(emailId: number): void {
    this._router.navigate(['emails', emailId]);
  }
  public getEmailId(route: ActivatedRoute): number {
    let realValue = route.snapshot.params['emailId'];

    return +realValue;
  }

  // email templates
  public goToAddEmailTemplate(): void {
    this._router.navigate(['settings', 'email-templates', 'new']);
  }
  public goToEditEmailTemplate(emailTemplateId: number): void {
    this._router.navigate(['settings', 'email-templates', emailTemplateId]);
  }
  public goToEmailTemplatesList(): void {
    this._router.navigate(['settings', 'email-templates', 'list']);
  }
  public getEmailTemplateIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['emailTemplateId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToRecruitmentStepsList(): void {
    this._router.navigate(['settings', 'recruitment-steps', 'list']);
  }

  public showApplicationRejection(applicationId: number, candidateEmail: string, selectionStepId: number, isGeneralApplication: boolean): Observable<boolean> {
    return this.openApplicationStatusEditor(applicationId, candidateEmail, true, selectionStepId, true, isGeneralApplication);
  }

  public showApplicationStatusEditor(applicationId: number, candidateEmail: string, isGeneralApplication: boolean): Observable<boolean> {
    return this.openApplicationStatusEditor(applicationId, candidateEmail, false, null, false, isGeneralApplication);
  }

  // open job application status dialog
  public openApplicationStatusEditor(applicationId: number, candidateEmail: string, isRejection: boolean, selectionStepId: number | null, isSendEmailSelected: boolean, isGeneralApplication: boolean): Observable<boolean> {
    let data: ApplicationStatusDialogData = {
      applicationId: applicationId,
      candidateEmail: candidateEmail,
      isRejection: isRejection,
      selectionStepId: selectionStepId,
      isSendEmailSelected: isSendEmailSelected,
      isGeneralApplication: isGeneralApplication
    };

    var dialog = this._dialog.open(JobApplicationStatusComponent, {
      hasBackdrop: true,
      panelClass: 'sc-modal',
      width: '95%',
      maxWidth: '1000px',
      maxHeight: '98vh', //set max height to 98 viewport height (viewable screen's height') for the opened dialog in order to reach Send and Close buttons through scrollbar when screen resolution is not compatible
      data: data
    });

    return dialog.afterClosed().pipe(
      map(r => !!r)
    );
  }

  // open permissions dialog
  public showFeedbackPermissionsEditor(applicationId: number, selectionStepId: number, applicationFeedbackType: ApplicationFeedbackType): Observable<boolean> {
    let data: PermissionsDialogData = {
      applicationId: applicationId,
      selectionStepId: selectionStepId,
      applicationFeedbackType: applicationFeedbackType
    };

    var dialog = this._dialog.open(PermissionsEditorComponent, {
      hasBackdrop: true,
      panelClass: 'sc-modal',
      width: '95%',
      maxWidth: '1000px',
      data: data
    });

    return dialog.afterClosed().pipe(
      map(r => !!r)
    );
  }

  // open dialog to get email address of the interviewer and send him link with feedback for him to fill
  public showCollectFeedbackEditor(command: CollectFeedbackCommand): Observable<boolean> {
    let data: CollectFeedbackDialogData = {
      templateVersionId: command.templateVersionId,
      selectionStepId: command.recruitmentStepId,
      applicationId: command.applicationId,
      canAttachDocuments: command.canAttachDocuments
    };

    var dialog = this._dialog.open(CollectFeedbackRequestEditorComponent, {
      hasBackdrop: true,
      panelClass: 'sc-modal',
      width: '95%',
      maxWidth: '1000px',
      maxHeight: '87vh', //set max height to 87 viewport height (viewable screen's height') for the opened dialog in order to reach Send and Close buttons through scrollbar when screen resolution is not compatible
      data: data
    });

    return dialog.afterClosed().pipe(
      map(r => !!r)
    );
  }

  // reports
  public goToCreateNewReport(): void {
    this._router.navigate(['reports', 'new']);
  }

  public goToReportEditor(reportId: number): void {
    this._router.navigate(['reports', reportId, 'editor']);
  }

  // reports list
  public goToReportsList(): void {
    this._router.navigate(['reports', 'list']);
  }

  public getReportId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['reportId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  // documents
  public goToCandidateDocuments(candidateId: number): void {
    this._router.navigate(['candidates', candidateId, 'documents']);
  }

  // application review
  public goToApplicationReview(candidateId: number, applicationId: number): void {
    this._router.navigate(['candidates', candidateId], {
      queryParams: {
        'applicationId': applicationId
      }
    });
  }

  public getApplicationId(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.queryParams['applicationId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public getReferenceCheckPublicId(route: ActivatedRoute): string {
    let realValue = route.snapshot.queryParams['pid'];

    return realValue;
  }

  public goToMyGeneralApplications(countryId: number, getUnprocessedApplications: boolean): void {
    this.goToCandidatesList(null, [], true, countryId, getUnprocessedApplications);
  }

  public goToGeneralApplications(): void {
    this._router.navigate(['dashboard/general-applications']);
  }

  public goToUnprocessedGeneralApplications(): void {
    this._router.navigate(['dashboard/general-applications'], {
      queryParams: {
        'unprocessed': true
      }
    });
  }

  public goToListOfValuesOptions(listOfValuesId: number): void {
    this._router.navigate(['settings', 'list-of-values', listOfValuesId, 'details']);
  }

  public goToHearAboutSabisValues(hearAboutSabisCategoryId: number): void {
    this._router.navigate(['settings', 'hear-about-sabis', 'categories', hearAboutSabisCategoryId, 'items']);
  }

  public goToCreateJobRequisition(hiringRequestId?: number | null): void {
    var queryParams = hiringRequestId ? {
      'hrId': hiringRequestId
    } : null;

    this._router.navigate(['job-requisitions', 'new'], {
      queryParams: queryParams
    });
  }

  public goToCreateContractType(): void {
    this._router.navigate(['settings', 'contract-types', 'new']);
  }

  public goToEditContractType(contractTypeId: number): void {
    this._router.navigate(['settings', 'contract-types', contractTypeId]);
  }

  public getContractTypeIdForEditor(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['contractTypeId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToContractTypeList(): void {
    this._router.navigate(['settings', 'contract-types', 'list']);
  }

  public getAnnouncementIdForEditor(route: ActivatedRoute): number | null {
    let val = route.snapshot.params['announcementId'];
    if (!!val) {
      return +val;
    }

    return null;
  }

  public goToRecruitmentEventsList(): void {
    this._router.navigate(['recruitment-events', 'list']);
  }

  public getRecruitmentEventIdForEditor(route: ActivatedRoute): number | null {
    let val = route.snapshot.params['recruitmentEventId'];
    if (!!val) {
      return +val;
    }

    return null;
  }

  public goToWebsitePopupsList(): void {
    this._router.navigate(['website-popup', 'list']);
  }

  public getWebsitePopupIdForEditor(route: ActivatedRoute): number | null {
    let val = route.snapshot.params['websitePopupId'];
    if (!!val) {
      return +val;
    }

    return null;
  }

  public getRecruitmentEventIdForApplications(route: ActivatedRoute): number | null {
    let val = route.snapshot.params['recruitmentEventId'];
    if (!!val) {
      return +val;
    }

    return null;
  }

  public getApplicationIdForRecruitmentEvent(route: ActivatedRoute): number | null {
    let realValue = route.snapshot.params['applicationId'];
    if (!!realValue) {
      return +realValue;
    }

    return null;
  }

  public goToRecruitmentEventApplicationsList(recruitmentEventId: number): void {
    this._router.navigate(['recruitment-events', recruitmentEventId, 'applications']);
  }

  public goToRecruitmentEventApplicationScreening(recruitmentEventId: number, applicationId: number): void {
    this._router.navigate(['recruitment-events', recruitmentEventId, 'applications', applicationId]);
  }
}

